/**
 * scroll.js — Scrollen, das prefers-reduced-motion respektiert.
 *
 * @description
 *   `scrollIntoView({ behavior: 'smooth' })` war an sechs Stellen im Baum
 *   fest verdrahtet. Ein weiches Scrollen ist eine Bewegung ueber die ganze
 *   Seite — genau die Sorte, die `prefers-reduced-motion` abschalten soll,
 *   und die einzige, die den ganzen Viewport erfasst.
 *
 *   🔴 Der Browser schaltet sie NICHT von selbst ab. `scroll-behavior:
 *   smooth` in CSS folgt der Praeferenz, die `behavior`-Option in JS nicht —
 *   sie ueberschreibt sie. Deshalb braucht jede Aufrufstelle die Abfrage.
 *
 *   Statt sie sechsmal zu wiederholen, steht sie hier einmal.
 */

/** 'smooth' oder 'auto' — je nach Nutzerpraeferenz. */
export function scrollBehavior() {
  try {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  } catch {
    // matchMedia fehlt in sehr alten Umgebungen und in manchen Test-Runnern.
    // 'auto' ist die sichere Antwort: es bewegt sich nicht.
    return 'auto';
  }
}

/**
 * Scrollt ein Element in den Blick — weich, oder sofort bei reduzierter Bewegung.
 *
 * @param {Element|null|undefined} el
 * @param {{block?: ScrollLogicalPosition, inline?: ScrollLogicalPosition}} [opts]
 */
export function scrollIntoViewRespectingMotion(el, opts = {}) {
  if (!el || typeof el.scrollIntoView !== 'function') return;
  el.scrollIntoView({
    behavior: scrollBehavior(),
    block: opts.block || 'start',
    inline: opts.inline || 'nearest',
  });
}
